import { PARTNER_SLUGS } from './constants'

export const getConnectedStoresText = (slug: string) => {
  switch (slug) {
    case PARTNER_SLUGS.SHIPDAY:
      return 'This means all self delivered orders for these stores can be managed from your Shipday account.'
    case PARTNER_SLUGS.LIGHTSPEED:
      return 'This means all orders automatically arrive in the POS, reducing manual work, mistakes, and missed orders.'
    default:
      return 'These stores are connected to this integration.'
  }
}

export const getUnconnectedStoresText = (slug: string) => {
  switch (slug) {
    case PARTNER_SLUGS.SHIPDAY:
      return 'Connecting them will streamline self-managed delivery operations.'
    case PARTNER_SLUGS.LIGHTSPEED:
      return 'Connecting them will streamline order handling and reduce the need for manual entry.'
    default:
      return 'These stores are not yet connected to this integration.'
  }
}
